import React from "react";
import authService from "./AuthService";
import config, { getApiUrl } from "./config";
import {Link} from "react-router-dom";
import "./ApplicationComponents.css";
import {vscodeDark} from "@uiw/codemirror-theme-vscode";
import {langs} from "@uiw/codemirror-extensions-langs";
import ReactCodeMirror from "@uiw/react-codemirror";
import toast from "react-hot-toast";

type ApplicationComponentsProperties = {}

type ApplicationComponent = {
    imageReference: string
    friendlyName: string
    version: string
}

type ApplicationComponentsState = {
    applicationComponents: Array<ApplicationComponent>
    showUploadDialog: boolean
    manifest: string
    dockerImage: File | null
}

class ApplicationComponents extends React.Component<ApplicationComponentsProperties, ApplicationComponentsState> {
    private updateIntervalId: number | undefined;

    constructor(props: ApplicationComponentsProperties) {
        super(props);
        this.state = {
            applicationComponents: new Array<ApplicationComponent>(),
            showUploadDialog: false,
            manifest: "",
            dockerImage: null
        }
    }

    componentDidMount() {
        this.fetchApplicationComponents();
        this.updateIntervalId = window.setInterval(() => this.fetchApplicationComponents(), 5000);
    }

    componentWillUnmount() {
        clearInterval(this.updateIntervalId);
    }

    private manifestDropEvent = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        const file = event.dataTransfer.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            if (event.target) {
                this.setState({manifest: event.target.result as string})
            }
        }
        reader.readAsText(file);
    }

    private uploadApplicationComponent = () => {
        let data = new FormData();
        data.append('image', this.state.dockerImage!)
        data.append('manifest', this.state.manifest)

        this.setState({
            showUploadDialog: false,
            manifest: "",
            dockerImage: null
        });

        const response  = fetch(getApiUrl() + "/v1/component/application/", {
            method: "POST",
            headers: [
                ["Authorization", authService.authHeader()]
            ],
            body: data
        }).then((response) => {
            if (!response.ok) {
                throw new Error("Failed to upload application component")
            }
        });

        const _ = toast.promise(response, {
            loading: 'Uploading application component...',
            success: 'Application component uploaded',
            error: 'Failed to upload application component'
        });
    }

    render() {
        return (
            <div className="ApplicationComponents">
                <h2>Application Components</h2>

                {this.state.applicationComponents.length > 0 ? <div className="ApplicationComponents-list">
                    {this.state.applicationComponents.map((component) => {
                        return (
                            <Link to={"/component/application/" + component.imageReference + "/" + component.version}
                                  className="ApplicationComponents-component" key={component.imageReference + component.version}>
                                {component.friendlyName}<small
                                className="ApplicationComponents-friendlyName">{component.version}</small>
                            </Link>);
                    })}
                </div> : <div className="ApplicationComponents-list">
                    <div className="ApplicationComponents-empty">No application components found</div>
                </div>}
                <button className="Home-link" onClick={() => this.setState({showUploadDialog: true})}>Upload application
                    component
                </button>
                {this.state.showUploadDialog && <div className="ApplicationComponents-upload">
                    <div className="ApplicationComponents-upload-content">
                        <h5>Manifest</h5>
                        <div className="ApplicationComponents-upload-scrollarea">
                            <ReactCodeMirror theme={vscodeDark}
                                             basicSetup={{
                                                 highlightActiveLineGutter: false,
                                                 highlightActiveLine: false,
                                             }}
                                             extensions={[langs.json()]}
                                             value={this.state.manifest}
                                             onChange={(value) => this.setState({manifest: value})}
                                             onDrop={this.manifestDropEvent}/>
                        </div>
                        <h5>Docker image (tar archive)</h5>
                        <input type="file" accept=".docker"
                               onChange={(e) => this.setState({dockerImage: e.target.files![0]})}/>
                        <div className="ApplicationComponents-upload-buttons">
                            <button onClick={this.uploadApplicationComponent}
                                    disabled={this.state.manifest == "" || this.state.dockerImage === null}>Upload
                            </button>
                            <button onClick={() => this.setState({
                                showUploadDialog: false,
                                manifest: "",
                                dockerImage: null
                            })}>Cancel
                            </button>
                        </div>
                    </div>
                </div>}
            </div>
        );
    }

    private fetchApplicationComponents() {
        fetch(getApiUrl() + "/v1/component/application/", {
            headers: [
                ["Accept", "application/json"],
                ["Authorization", authService.authHeader()]
            ]
        })
            .then(response => response.json() as Promise<ApplicationComponent[]>)
            .then((response) => {
                this.setState({
                    applicationComponents: response
                })
            })
            .catch((error) => {
                console.error(error);
            });
    }
}

export default ApplicationComponents;
